<!-- uiTick keeps this view in sync when the controller mutates plain fields -->
@let _tick = controller().uiTick();
<div class="list-filter-tabs-row" [attr.data-ui-tick]="_tick">
    <dx-button
        class="add-filter-tab-button"
        icon="plus"
        stylingMode="text"
        [hint]="'add_filter_tab' | transloco"
        (onClick)="controller().addTabFromCurrentFilter()"
    ></dx-button>
    <dx-tabs
        secondary="secondary"
        [width]="'100%'"
        [showNavButtons]="true"
        [scrollByContent]="true"
        [selectedIndex]="controller().selectedTabIndex"
        [items]="controller().tabs"
        [iconPosition]="'end'"
        itemTemplate="tabItem"
        (onItemClick)="controller().onTabClick($event)"
    >
        <div *dxTemplate="let item of 'tabItem'" class="dx-tab-item-custom">
            <span class="tab-text">{{ item.text }}</span>
            @if (item.icon) {
                <span class="tab-icon-wrapper" [attr.id]="'tab-icon-' + item.key">
                    <dx-tooltip [target]="'#tab-icon-' + item.key" [showEvent]="'mouseenter'" [hideEvent]="'mouseleave'" [position]="'top'">
                        <div *dxTemplate="let data of 'content'">
                            {{ item.iconTooltip || 'Information' }}
                        </div>
                    </dx-tooltip>
                    <i class="dx-icon {{ item.icon }} tab-icon"></i>
                </span>
            }
            @if (item.isCustom) {
                <button
                    type="button"
                    class="tab-close-button"
                    [attr.aria-label]="'remove' | transloco"
                    (click)="controller().removeCustomTab(item.key, $event)"
                >
                    <i class="dx-icon dx-icon-close"></i>
                </button>
            }
        </div>
    </dx-tabs>
</div>

@if (controller().isCreateFilterTabPopupOpened) {
    <ng-template #createFilterTabTitle>
        <div class="create-filter-tab-popup__title">
            <span class="dx-icon dx-icon-plus create-filter-tab-popup__title-icon" aria-hidden="true"></span>
            <span>{{ 'create_tab' | transloco }}</span>
        </div>
    </ng-template>

    <app-form-popup
        [width]="400"
        [(visible)]="controller().isCreateFilterTabPopupOpened"
        [isSaveDisabled]="!controller().isCreateFilterTabFormValid"
        (save)="controller().onCreateFilterTabSave()"
        (closed)="controller().closeCreateFilterTabPopup()"
        [titleTemplate]="createFilterTabTitle"
    >
        <dx-form
            #createFilterTabForm
            class="create-filter-tab-name plain-styled-form"
            [formData]="controller().createFilterTabFormData"
            [colCount]="1"
            [showColonAfterLabel]="false"
            [showRequiredMark]="true"
            [requiredMark]="'*'"
            (onFieldDataChanged)="controller().onCreateFilterTabFormChanged()"
        >
            <dxi-form-item
                dataField="name"
                editorType="dxTextBox"
                [label]="{ text: 'label_name' | transloco }"
                [isRequired]="true"
                [validationRules]="controller().createFilterTabNameValidationRules"
                [editorOptions]="controller().createFilterTabNameEditorOptions"
            ></dxi-form-item>
        </dx-form>
    </app-form-popup>
}
